<template>
  <div class="page">

    <div class="mang">
      <div class="banner">
        <!-- <img
            src="https://files.sciconf.cn/meeting/2022/11176/image/20220729/2022072913365968947510123.jpg"
            alt=""
          /> -->
      </div>
      <div class="sub-content">
        <div class="title">
          {{ info.name }}
        </div>
        <div class="border">
          <div class="with-line">
            <i>
              <img src="../assets/du.png" alt="">
            </i>
          </div>
        </div>
        <div class="from">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="作者">
              <el-input v-model="form.author"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="form.mobile"></el-input>
              <span style="color:red;font-size:10px">*用于接收壁报审核通知短信，请确认填写手机号正常使用</span>
            </el-form-item>
            <el-form-item label="单位">
              <el-input v-model="form.unit"></el-input>
            </el-form-item>
            <el-form-item label="层级">
              <el-cascader v-model="form.level" :options="options" :props="{
                value: 'id',
                label: 'label',
                children: 'children',
                checkStrictly: true, emitPath: false
              }" clearable>
              </el-cascader>
            </el-form-item>
            <el-form-item label="文献内容">

              <!-- {{fileList}} -->
              <el-upload accept=".pdf" action="String" :limit="1" :before-upload="beforeUpload" :on-success="upSuccess"
                :file-list="fileList" ref="upload" :on-error="upError" :http-request="handleUploadForm">
                <el-button size="small" type="primary">
                  <span class="iconfont icon-shangchuan" />上传文件
                </el-button>
                <p slot="tip" class="el-upload__tip" style="color:red">
                  <svg t="1672047284968" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2694" width="200" height="200"><path d="M512 14.208c274.56 0 497.792 223.168 497.792 497.792 0 274.56-223.168 497.792-497.792 497.792C237.44 1009.792 14.208 786.56 14.208 512 14.208 237.44 237.44 14.208 512 14.208z m0 71.104A427.072 427.072 0 0 0 85.312 512 427.072 427.072 0 0 0 512 938.688 427.072 427.072 0 0 0 938.688 512 427.072 427.072 0 0 0 512 85.312z m35.584 628.16v71.104H476.416v-71.04h71.168z m0-474.048v402.944H476.416V239.424h71.168z" fill="#f56c6c" p-id="2695"></path></svg>
                  仅支持选择pdf文件 建议文件内页数不超过一页 单份文件大小不超过2m</p>
                <p slot="tip" class="el-upload__tip" style="color:red">若手机端找不到需上传的文件，请将此页发送至电脑端，使用电脑上传</p>
              </el-upload>


            </el-form-item>
            <el-form-item style="position: fixed;
    bottom: 0;">
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button @click="back()">返回上一页</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { addLiterature, getCategoryLists, uploadFile } from '@/api/api'
export default {
  name: "Home",
  components: {
    // HelloWorld,
  },
  data() {
    return {
      sou: "",
      images: [],
      form: {
        name: '',
        author: '',
        unit: '',
        level: '',
        content: '',
        mobile: '',
        url: '',
        url_arr: '',
      },
      event_id: '',
      info: '',
      id: '',
      options: [],//分类数据
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入壁报名称', trigger: 'blur' },
        ],
        author: [
          { required: true, message: '请输入作者名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请输入作者单位', trigger: 'blur' }
        ],
        pdfUrl: [
          { required: true, message: '请上传壁报', trigger: 'blur' }
        ]
        //   type: [
        //     { type: 'array', required: true, message: '请选择壁报分类', trigger: 'change' }
        //   ],


      }
    };
  },
  mounted() {
    this.event_id = this.$route.query.event_id
    this.id = this.$route.query.id
    this.info = JSON.parse(this.$route.query.info)
    // console.log(this.info)
    document.title = this.info.name;
    getCategoryLists({ event_id: this.event_id }).then((response) => {
      console.log(response)
      // this.treeData = response.data;

      response.data.forEach((value, index) => {
        this.$nextTick(() => {

          //     value['isEdit'] = false;
          //     // console.log(value)
          //    if(value.children.length !=0){
          //         value.children.forEach((el)=>{
          //             el['isEdit'] = false;
          //         })
          //     }
          //     this.treeData.push(value);

        })
        this.getTypeList(response.data)
        this.options = response.data





      })

    })
  },
  methods: {
    handimg(src) {
      var arr = [];
      arr.push(src)
      this.$viewerApi({
        images: arr,
      })
    },
    toupush() {
      this.$router.push({
        path: '/leve'
      })
    },
    getTypeList(listData) {

      listData.forEach((items) => {
        // console.log(items.children.length)
        if (items.children.length > 0) {
          items.disabled = true;
          // if(el.children.length !=0){
          items.children.forEach((el) => {
            // el.children.push({
            //     disabled:true
            // })
            this.$nextTick(() => {
              // el.disabled=true
              // console.log(el)


            })


          })
          // }
          this.getTypeList(items.children)
        } else {
          items.children = []
        }
      })
    },
    handleExceed: function () {
    },
    // this.$msg(); 为自定义全局提示
    // 上传文件之前
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["pdf"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$msg("上传文件只能是 pdf、doc、docx、xls、xlsx格式", "error");
        this.$message({
          message: '上传文件只能是 pdf格式',
          type: 'warning'
        });
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message("上传文件大小不能超过 2MB", "error");
        return false;
      }
    },
    // 上传成功
    upSuccess(e) {
      this.$msg("上传成功", "error");
    },
    // 上传失败
    upError(e) {
      this.$message("上传失败", "error");
    },
    handleUploadForm(param) {
      console.log(this.pid)
      let thisInfo = this
      let formData = new FormData();
      formData.append('file', param.file)
      uploadFile(formData).then((response) => {
        if (response.code == 1) {
          this.form.url = response.data.url;
          this.form.url_arr = response.data.url_arr;
        } else {
          this.$message("上传失败", "error");
        }
      }).catch((err) => {
        this.$message("上传失败", "error");
      })
      // thisInfo.$axios.post('api/user/update_Info/', formData).then((res) => {
      //     if (res.status === 200) {
      //     // thisInfo.$message.success('修改信息成功')
      //     } else {
      //     // thisInfo.$message.success('修改信息失败')
      //     }
      //     thisInfo.formFileList = []
      //     thisInfo.uploadFormFileList = []
      // })
    },
    onSubmit() {
      addLiterature({ event_id: this.event_id, category_id: this.form.level.toString(), title: this.form.name, author: this.form.author, mobile: this.form.mobile, company: this.form.unit, url: this.form.url, url_arr: this.form.url_arr }).then((response) => {
        if (response.code == 1) {
          this.$message.success({
            message: response.msg
          })
          this.dialogliteratureHand = false;
          this.$refs['form'].resetFields();
          this.form.name = '';
          this.form.author = '';
          this.form.level = ''
          this.form.mobile = '';
          this.form.unit = '';
          this.form.url = '';
          this.form.url_arr = '';
          this.$nextTick(() => {
            this.$refs.upload.clearFiles();
          })
        } else {

        }
      })
    },
    back(){
      this.$router.go(-1)
    }
  },
};
</script>
<style lang="scss" scoped>
.page {
  .banner {
    img {
      width: 100%;
      margin: 0 auto;
    }
  }

  .sub-content {
    padding: 1rem;
    font-size: 0.6rem;
    padding-bottom: 1.5rem;
    flex: 1;
    word-break: break-word;

    .title {
      width: 100%;
      text-align: center;
      font-size: 1.3rem;
      font-weight: 500;
      // margin: 20px;
    }

    .border {
      width: 100%;
      display: inline-flex;
      justify-content: center;
      margin-bottom: 20px;
      margin-top: 20px;

      .with-line {
        width: 100%;
        font-size: 16px;
        color: #999;
        margin: 0 auto;
        position: relative;
        text-align: center;

        img {
          width: 2rem;
          height: 2rem;
        }
      }

      .with-line:before {
        content: "";
        border-top: 3px solid #ededed;
        display: block;
        position: absolute;
        width: 40%;
        top: 10px;
        left: 0;
        margin-right: 12px;
      }

      .with-line:after {
        content: "";
        border-top: 3px solid #ededed;
        display: block;
        position: absolute;
        width: 40%;
        top: 10px;
        right: 0;
        margin-left: 12px;
      }
    }

    .search-box {
      padding: 0.4rem 1rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      border: 1px solid #ddd;
      // height: 1.8rem;
      -webkit-border-radius: 0.9rem;
      -moz-border-radius: 0.9rem;
      border-radius: 0.9rem;
      position: relative;
      overflow: hidden;
      background-color: #fff;

      .van-cell-group::after {
        border: none !important;
      }
    }

    .flex {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
    }
  }

  ::v-deep .el-cascader {
    width: 100%;
  }
  ::v-deep .el-button{
    font-size: 12px;
  }
  .from {
    .tong {
      font-size: 12px;
      color: red;

      svg {
        width: 12px;
        height: 12px;
        margin-right: 6px;
      }
    }
  }

  .clearfix:before,
  .clearfix:after {
    clear: both;
    content: "";
    display: table;
  }

  @media screen and (min-width: 1201px) {
    .banner img {
      width: 1200px;
      display: block;
      margin: 0 auto;
    }

    .sub-content,
    .banner {
      width: 1200px;
      display: block;
      margin: 0 auto;
    }

    .bibao-item {
      width: 16.666666% !important;
    }
  }

  @media screen and (min-width: 769px) {
    .bibao-details .bibao-details-item:nth-child(2n-1) {
      margin-right: 0.5rem;
    }
  }

  @media screen and (min-width: 769px) {
    .bibao-details .bibao-details-item {
      width: -webkit-calc(99.5% / 2);
      width: -moz-calc(99.5% / 2);
      width: calc((100% - 0.5rem) / 2);
      float: left;
    }
  }

  .tou {
    position: fixed;
    top: 76%;
    left: 76%;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.1);

    .jia {
      font-size: 2.5rem;
      text-align: center;
    }

    .title {
      font-size: 18px;
      text-align: center;
    }
  }

  .ding {
    top: 90%;

    .jia {
      font-size: 3rem;

    }

    svg {
      background: none;
      // width: 3rem;
      // height: 3rem;
    }
  }

  svg {
    width: 1.2rem;
    height: 1.2rem;
    background: #ffffff;
    border: 0px solid #000000;
    box-shadow: 0px 0px 17px 1px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  }
}
</style>
    